"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryHeader = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var styled_components_1 = __importDefault(require("styled-components"));
var factory_1 = require("../internal/factory");
var css_types_1 = require("../internal/css-types");
exports.FactoryHeader = factory_1.factory({
    prefix: 'Header',
    settings: {
        tag: type_guard_1.enums(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
        font: css_types_1.font,
        palette: type_guard_1.props({
            text: css_types_1.color.any
        })
    },
    component: function (settings, _a) {
        var font = _a.css.font;
        return styled_components_1.default(settings.tag)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* Remove default browser margin */\n      margin: 0;\n\n      /* Style font */\n      ", "\n      color: ", ";\n    "], ["\n      /* Remove default browser margin */\n      margin: 0;\n\n      /* Style font */\n      ", "\n      color: ", ";\n    "])), font(settings.font), settings.palette.text);
    }
}).FactoryHeader;
var templateObject_1;
